<template lang="pug">
    .animations(ref='animation')
        svg(width='100%' viewBox='0 0 289 143' preserveAspectRatio='xMidYMid meet')
            path(d='M160.382 73.1878L131.915 72.4949L118.367 57.5291L170.803 58.2219L160.382 73.1878Z' fill='black')
            path(d='M0.892578 36.7431L58.4331 0L94.0676 19.3895L89.4844 25.0071L58.9435 11.2244L4.9654 78.6028L2.28563 89.0703L0.892578 36.7431Z' fill='black')
            path(d='M288.107 36.7431L230.566 0L194.932 19.3895L199.515 25.0071L230.066 11.2244L284.034 78.6028L286.714 89.0703L288.107 36.7431Z' fill='black')
            path(d='M0 36.8604C0 36.8604 112.561 49.5664 114.081 50.0781C115.613 50.5897 137.157 67.922 137.157 67.922L110.785 142.623L26.3723 141.302L1.97792 125.44L0 36.8604Z' fill='black')
            path(d='M13.8457 47.5411C13.8457 47.5411 103.671 57.6889 104.894 58.094C106.117 58.499 123.312 72.335 123.312 72.335L102.257 131.943L34.8904 130.887L15.4195 118.224L13.8457 47.5411Z' fill='black')
            path(d='M288.999 36.8604C288.999 36.8604 176.438 49.5664 174.918 50.0781C173.397 50.5897 151.842 67.922 151.842 67.922L178.225 142.613L262.637 141.291L287.032 125.43L288.999 36.8604Z' fill='black')
            g(transform='translate(50 43)')     
                g(ref='crack')
                    path(d='M272.416 48.3095L269.589 49.676L251.397 53.5108L251.205 53.5511L251.092 53.7109L224.926 90.636L224.63 91.0528L225.054 91.3392L255.73 112.099L222.755 92.5698L222.599 92.4776L222.42 92.5064L213.1 94.0064L212.794 94.0555L212.702 94.351L203.678 123.251L210.895 97.6911L211.069 97.0777L210.432 97.0555L180.044 96.0012L177.32 95.6144L213.25 90.495L214.329 90.3412L213.508 89.6235L180.55 60.8164C180.653 60.715 180.894 60.5435 181.428 60.3552C181.432 60.3565 181.437 60.358 181.442 60.3597C181.521 60.3864 181.639 60.4389 181.803 60.5253C182.128 60.6967 182.572 60.9707 183.125 61.3403C184.228 62.0774 185.721 63.1655 187.476 64.4937C190.983 67.1486 195.507 70.7428 199.984 74.3575C204.459 77.9716 208.883 81.6032 212.189 84.3315C213.841 85.6956 215.214 86.8338 216.174 87.631C216.654 88.0295 217.03 88.3428 217.287 88.5564L217.579 88.8003L217.654 88.8628L217.673 88.8786L217.678 88.8826L217.679 88.8836C217.679 88.8838 217.68 88.8839 218 88.5L217.68 88.8839L217.941 89.1018L218.239 88.939L225.573 84.939L225.681 84.88L225.75 84.7777L248.555 50.6274L272.416 48.3095Z' fill='white' stroke='white')

            g(transform='translate(3 0)') 
                g(ref='gap')
                    path(d='M166.113 72.1964C166.113 72.1964 179.704 60.4071 181.352 59.8528C183.011 59.2985 196.441 61.3345 196.441 61.3345L213.179 81.5128L230.513 52.2633L221.463 88.7079L248.271 50.1527L275.154 47.5411L274.187 90.9251H270.592H225.334L269.752 120.985L255.301 130.322L221.463 99.7724L210.117 131.602L200.759 131.751L210.414 97.5552L182.181 119.418L173.77 95.6152L206.554 86.5014L166.113 72.1964Z' fill='white')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'middle-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline();
            this.timeline
                .set(this.$refs.gap, {opacity: 0})
                .set(this.$refs.crack, {opacity: 0.5, scale: 0})
                .fromTo(this.$refs.crack, {scale: 0, opacity: 0.5}, {transformOrigin: '50% 50%', duration: 1, scale: 1, opacity: 1}, 0)
                .set(this.$refs.gap, {opacity: 1});
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.animations {
    width: 100%;
    padding-left: calc(var(--grid-column) * 2);
    @media (--viewport-tablet) {
        padding: 0;
    }
}
</style>
